module.exports = __webpack_public_path__ + "img/img-fachai-d.b7fa9b4a.png";